<template>
  <div class="user-info-skeleton__wrapper">
    <div v-if="isLoading" class="user-info-skeleton">
      <div class="skeleton-block ml-2"></div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.skeleton-block {
  width: 40px;
  height: 20px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
